import { createContext } from "react";

interface FormContextValue {
  hideLabel?: boolean;
  fixedLabelWidth?: React.CSSProperties["width"];
}

export const FormContext = createContext<FormContextValue>({});
